import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { isNotNullOrUndefined } from '@utils/utils';
import { formatDateTimeInTzWithLocale } from '@utils/dateWithTz';

interface ComponentProps {
  fullName: string;
  sentAt: string;
  timezoneId: string;
  dataTestId?: string;
}

const WeightBadge: React.FC<ComponentProps> = ({ fullName, sentAt, timezoneId, dataTestId }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      {isNotNullOrUndefined(fullName) && (
        <Badge filled={false} value={`${fullName}, ${formatDateTimeInTzWithLocale(sentAt, timezoneId)}`} highlightedValue={false} label={tr(`SentBadge.sent`, `Sent`)} dataTestId={dataTestId}></Badge>
      )}
    </>
  );
};

export default WeightBadge;
